import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { AlertCircle } from "lucide-react";

export default function GoogleCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sid = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sid }, { skipAuthRefresh: true });
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        navigate(data.role === "accountant" ? "/contabilista" : "/cliente", { replace: true });
      } catch (e) {
        window.history.replaceState(null, "", "/login");
        setError(formatApiError(e.response?.data?.detail) || e.message);
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen paper-grain flex items-center justify-center p-4" data-testid="google-callback">
      <div className="card-soft w-full max-w-md text-center">
        {error ? (
          <div data-testid="google-callback-error">
            <AlertCircle className="mx-auto text-[#991B1B]" size={28} />
            <p className="text-sm text-[#991B1B] mt-3">{error}</p>
            <button onClick={() => navigate("/login", { replace: true })} className="btn-primary w-full mt-5" data-testid="google-error-back-btn">
              Voltar ao início de sessão
            </button>
          </div>
        ) : (
          <div data-testid="google-callback-loading">
            <div className="mx-auto w-8 h-8 border-2 border-[color:var(--primary)] border-t-transparent rounded-full animate-spin" />
            <p className="text-sm text-[color:var(--ink-muted)] mt-4">A validar a sua conta Google…</p>
          </div>
        )}
      </div>
    </div>
  );
}
